export default __webpack_public_path__ + "static/media/pic1.ef90cf69.jpg";